import { render } from "./DonatePage.vue?vue&type=template&id=92d7ffe2&scoped=true"
import script from "./DonatePage.vue?vue&type=script&lang=js"
export * from "./DonatePage.vue?vue&type=script&lang=js"

import "./DonatePage.vue?vue&type=style&index=0&id=92d7ffe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92d7ffe2"]])

export default __exports__